import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateEvaluationCriteriaUseCaseInterface } from 'domain/usecases';

export class RemoteUpdateEvaluationCriteria
  implements UpdateEvaluationCriteriaUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: UpdateEvaluationCriteriaUseCaseInterface.Params,
  ): Promise<UpdateEvaluationCriteriaUseCaseInterface.Result> {
    const { id, ...restParams } = params;

    const requestUrl = `${this.url}/${id}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      body: restParams,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
